'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('commercial_stabilization', {
      url: '/account/housing/commercial_stabilization?jurisdiction&sta_recid&policyName',
      template: '<commercial-stabilization></commercial-stabilization>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null,     // Default value if not provided
        policyName: null     // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/commercial_stabilization/commercial_stabilization.routes.js